import moment from 'moment';

// 和暦を生成するヘルパー関数
let createJapaneseCalendar = year => {
  let name = '西暦';
  let newYear = year;
  if (moment().isAfter('2019-05-01') && year > 2018) {
    name = '令和';
    newYear = year - 2018;
  } else if (year > 1988) {
    name = '平成';
    newYear = year - 1988;
  } else if (year > 1925) {
    name = '昭和';
    newYear = year - 1925;
  } else if (year > 1911) {
    name = '大正';
    newYear = year - 1911;
  } else if (year > 1867) {
    name = '明治';
    newYear = year - 1867;
  }
  return `(${name}${newYear === 1 ? '元' : newYear}年)`;
};

// 年の選択肢を生成
let years = [];
let nowYear = new Date().getFullYear();
for (let i = 1900; i <= nowYear; i++) {
  if (i === 1980) {
    years.push({ value: '0000', text: '年' });
  }
  years.push({ value: String(i), text: `${i}年${createJapaneseCalendar(i)}` });
}

// ホテル詳細ルームのデフォルト値
const DEFAULT_HOTEL_DETAIL_ROOM = {
  amenities: [],
  cancellation_policy: null,
  description: null,
  hotel_id: null,
  plan_id: null,
  image_urls: [],
  meal_info: {},
  is_refundable: false,
  is_smoking: false,
  price: 0,
  refundable_date: null,
  title: null,
  display_price: 0,
  bed_type_title: null,
  official_plan_name_en: null,
  total_amount: 0,
  total_discount: 0,
  goto_discount: 0,
  local_coupon_price: 0,
  local_coupon_day_price: 0,
  bed_num: 0,
  capacity: 0,
  promotion: '',
  dp_display_price: 0,
  base_price: 0,
  price_with_flights: 0,
  room_stock: 0,
  selectable_bed_types: [],
  selectable_smoking_types: [],
  smoking_type: null,
  token: null,
  vendor_code: null,
  product_key: null,
  product_code: null,
  room_codes: null,
  sub_title_en: null,
};

// 名前付きエクスポート
export { DEFAULT_HOTEL_DETAIL_ROOM };

export default {
  // 会社情報
  COMPANY: {
    BOSS_POSITION: '代表取締役社長',
    BOSS_NAME: '平尾 丈',
    NAME: '株式会社アップルワールド',
    NAME_EN: 'APPLE WORLD INC.',
    ZIPCODE: '163-1114',
    ADDRESS: '東京都新宿区西新宿6-22-1 新宿スクエアタワー14階',
    PHONE: '03-6632-9001',
    FOUNDED_DATE: '1991年12月6日',
    TRAVEL_LICENSE: '観光庁長官登録旅行業第1576号',
    TRAVEL_LICENSE_ADDS: ['日本旅行業協会（JATA）正会員', 'ボンド保証会員'],
    TRAVEL_LICENSE_DATE: '2020年11月7日',
    TRAVEL_LICENSE_LIMIT:
      '令和7（2025）年11月8日から 令和12（2030）年11月7日まで',
    TRAVEL_INDUSTRY_ADMIN: '小林 瑞彦・小島 潤之',
    CAPITAL: '2億円',
  },

  // Session Storageのキー
  SEARCH_COND_KEYS: {
    MODE: 'mode',
    FLIGHT: 'flight_search_cond',
    BACK_FLIGHT: 'back_flight_search_cond',
    HOTEL: 'hotel_search_cond',
  },

  HISTORY_KEYS: {
    DEPARTURE_AIRPORT: 'dep_airport_history',
    ARRIVAL_AIRPORT: 'arr_airport_history',
    AREA_ID: 'area_id_history',
  },

  MAX_HISTORY: 3,
  APPLICATIONS: 'applications',

  // reservation token
  HOTEL_RESERVATION_TOKEN: { key: '__hrt__' },
  APL_NO_CROSS_SELL: { key: 'apl_no_cross_sell' },

  // 申込者を含む搭乗者上限
  DEFAULT_MAX_PASSENGER_NUM: 6,
  AIRLINE_PASSENGERS: {
    SKY: 7, // 本来は8まで可能だがgocrawlerで子供料金を取得するために7までに制限
    MM: 9,
    IJ: 9,
  },

  // 手数料などの価格
  RECIEPT_PRICE: 350,
  BANK_TRANSFER_FEE: 1500,

  // ローディング中文言
  LOADING_TEXT_HOTEL_DETAIL: '最新のお部屋情報を検索しています',
  LOADING_TEXT_APPLICATION_CHECK: 'お申込み内容を確認しています',
  // ANA(TF)は確認処理(ProcessDetails)に時間がかかるため、期待値を伝える専用文言。
  LOADING_TEXT_ANA_APPLICATION_CHECK:
    'ご予約内容を確認しています。\n処理に1分程度かかる場合があります。ブラウザの「戻る」は押さずにそのままお待ちください。',
  LOADING_TEXT_APPLICATION_EXEC: 'お申込み処理を行っております',
  LOADING_TEXT_APPLICATION_LOAD: 'お申込み情報を取得しています',
  LOADING_TEXT_HOTEL_EXEC: 'ホテルのお申込み処理を行っております',
  LOADING_TEXT_AIR_EXEC: '航空券のお申込み処理を行っております',
  LOADING_TEXT_RESELECT_TICKET: '商品情報を更新中です',

  PAYMENT_STEPS: {
    INITIAL: 0,
    AUTHORIZED: 1,
    AUTHORIZED_WITH_SECURE_CARD: 2,
  },

  // 決済関連定数はPaymentMethods.jsから再エクスポート（互換性維持のため）
  // 新規コードではPaymentMethods.jsから直接importすることを推奨
  // import { PAYMENT_METHODS, PAYMENT_CATEGORIES } from '~/src_common/constants/PaymentMethods';

  MAX_RETRY_APPLICATION: 25, // 申込処理のリトライ回数（旧MAX_RETRY）
  WAITING_MSEC: 4000,
  TICKET_TYPE_SIMPLE_PEACH: 6,

  // 年(元号含む)
  YEARS: years,

  // 都道府県
  PREFECTURES: [
    { id: 1, name: '北海道' },
    { id: 2, name: '青森県' },
    { id: 3, name: '岩手県' },
    { id: 4, name: '宮城県' },
    { id: 5, name: '秋田県' },
    { id: 6, name: '山形県' },
    { id: 7, name: '福島県' },
    { id: 8, name: '茨城県' },
    { id: 9, name: '栃木県' },
    { id: 10, name: '群馬県' },
    { id: 11, name: '埼玉県' },
    { id: 12, name: '千葉県' },
    { id: 13, name: '東京都' },
    { id: 14, name: '神奈川県' },
    { id: 15, name: '新潟県' },
    { id: 16, name: '富山県' },
    { id: 17, name: '石川県' },
    { id: 18, name: '福井県' },
    { id: 19, name: '山梨県' },
    { id: 20, name: '長野県' },
    { id: 21, name: '岐阜県' },
    { id: 22, name: '静岡県' },
    { id: 23, name: '愛知県' },
    { id: 24, name: '三重県' },
    { id: 25, name: '滋賀県' },
    { id: 26, name: '京都府' },
    { id: 27, name: '大阪府' },
    { id: 28, name: '兵庫県' },
    { id: 29, name: '奈良県' },
    { id: 30, name: '和歌山県' },
    { id: 31, name: '鳥取県' },
    { id: 32, name: '島根県' },
    { id: 33, name: '岡山県' },
    { id: 34, name: '広島県' },
    { id: 35, name: '山口県' },
    { id: 36, name: '徳島県' },
    { id: 37, name: '香川県' },
    { id: 38, name: '愛媛県' },
    { id: 39, name: '高知県' },
    { id: 40, name: '福岡県' },
    { id: 41, name: '佐賀県' },
    { id: 42, name: '長崎県' },
    { id: 43, name: '熊本県' },
    { id: 44, name: '大分県' },
    { id: 45, name: '宮崎県' },
    { id: 46, name: '鹿児島県' },
    { id: 47, name: '沖縄県' },
  ],

  AVAILABLE_BAGGAGE_FLIGHTS: ['JJP', 'APJ'],

  PREFIX_KAIGAI_URL: 'international-air',

  ASUKA_STATUS: {
    LRT: 'LRT', // Low Risk Transaction
    BIAT: 'BIAT', // Risk Middle and authenticate success
    SGE: 'SGE', // SafeGuard Executed
    NMV: 'NMV', // Null or Missing Value
    MM: 'MM', // Maintenance Mode
    TIMEOUT: 'TIMEOUT', // timeout
    FAILED: 'FAILED', // failed
    UB: 'UB', // Unsupported browser
  },

  /*
  航空券　予約日の時点で 12歳以上 118歳未満
  ホテル　予約日の時点で 18歳以上 99歳以下
  搭乗日基準ではなく、予約日基準
  */
  RESERVABLE_AGE_HOTEL: 18,
  RESERVABLE_AGE_FLIGHT: 12,
  RESERVABLE_MAX_AGE_HOTEL: 99,
  RESERVABLE_MAX_AGE_FLIGHT: 118,

  HOTEL_VENDER_TYPE: {
    single: 'EP2T',
    combined: 'EP2Q',
    cross_sell: 'EP2C',
  },

  BONUS_POINT_RATE: 0.3,

  AUTHENTICATION_FAIL_MESSAGE:
    'メールアドレスもしくはパスワードが正しくありません',

  NOT_SHOW_GLOBAL_NAV_PAGES: [
    'ApplicationCart',
    'ApplicationCartFromMeta',
    'ApplicationCartDirect',
    'ApplicationCartBackFromLogin',
    'ApplicationCartFromGoogleFlights',
    'ApplicationInsuranceEdit',
    'ApplicationConfirm',
  ],

  // PC版の商材メニュー（GrobalNav）のみ非表示にするページ。
  // SPのグローバルナビ・Footerナビ・ヘッダー内リンクには影響しない。
  NOT_SHOW_PC_GLOBAL_NAV_PAGES: [
    'ApplicationComplete',
    'ApplicationHotelComplete',
  ],

  // 既に存在していた共通定数
  PEACH_FLIGHT_CODE: 'APJ',
  GK_FLIGHT_CODE: 'JJP',
  VALUE_PEACH_TICKET_TYPE: 1,
  SIMPLE_PEACH_TICKET_TYPE: 6,
  GK_STARTER_PRICE_3_TICKET_TYPE: 6,
  SELECT_FLIGHT_PAGES: [
    'SelectFlight',
    'SelectFlightRoundTrip',
    'SelectBackFlight',
  ],
  DAYS_BEFORE_REFUND_DEADLINE_TO_INVALIDATE_DP_PLAN: 1, // 全額返金可能な期限のX日前（X日目を含む）になるとDPプランが無効になる日数。例: 1の場合、全額返金期限の1日前から無効。
  DAYS_BEFORE_FLIGHT_DEPARTURE_TO_INVALIDATE_DP_PLAN: 2, // DPプランが搭乗日のX日前（X日目を含む）に無効になる日数。例: 2の場合、搭乗日の2日前から無効。
  HOTEL_LOCATION_IDS: 'hotel_location_ids',
  HOTEL_BROWSE_HISTORY_KEY: 'hotel-browse-history',
  SKYSCANNER_REDIRECT_ID_KEY: 'skyscanner-redirect-id',
  MINIMUM_PAY_AMOUNT: 100,
  SPRING_FLIGHT_CODE: 'SJO',
  ANA_FLIGHT_CODE: 'ANA',
  // 即時決済 TF キャリア（Peach / ANA）。same-cart に複数の即時決済 TF 予約を
  // 混在させると 1 Application 内で部分予約・二重課金リスクがあるため相互排他にする。
  // キャリアを TF 化するたびにこの配列へ three_letter_code を追加する。
  TF_IMMEDIATE_PAY_CARRIERS: ['APJ', 'ANA'],
  // application_check のフロント側バックストップ・タイムアウト(ms)。
  // ProcessDetails 初回は成功でも最大 ~60s かかる実測のため（中央値 24.9s / p90 58.6s）、
  // プロキシ(nginx proxy_read_timeout=60s で 504)を下回る値にすると、成功するはずの
  // 予約を切ってしまう。よってプロキシより外側(>60s・アプリ上限120s未満)に置き、
  // 60s 超過時は nginx の 504 応答を Y(ゲートウェイエラー処理→再試行)に任せる。
  // 本値は「応答が全く返らない」場合の保険。(実測根拠・MED-1168/MED-1166)
  APPLICATION_CHECK_TIMEOUT_MS: 90000,
  NUMBER_OF_OTP_DIGITS: 6,

  // 航空会社キャンセル規定（2025年11月27日更新）
  AIRLINE_CANCELLATION_POLICIES: {
    JAL: {
      name: 'JAL/JTA/RAC',
      code: 'JAL',
      fares: [
        {
          name: 'フレックス',
          rules: [
            { period: '出発前', fee: '手数料はかかりません' },
            { period: '出発後', fee: '税抜運賃額の約20%相当額' },
          ],
          note:
            '※予約の取り消しのみを行い、後日払い戻しを行う場合は、払い戻し手続き日の手数料が適用となります。',
        },
        {
          name: '株主割引',
          rules: [
            { period: '出発時刻前まで', fee: '払戻手数料440円' },
            { period: '出発後', fee: '運賃額の20%＋払戻手数料440円' },
          ],
          note:
            '※予約の取り消しのみを行い、後日払い戻しを行う場合は、払い戻し手続き日の手数料が適用となります。',
        },
        {
          name: 'セイバー',
          rules: [
            { period: '出発前', fee: '税抜運賃額の約5％相当額' },
            { period: '出発後', fee: '税抜運賃額の100％' },
          ],
          note:
            '※予約の取り消しのみを行い、後日払い戻しを行う場合は、払い戻し手続き日の手数料が適用となります。',
        },
        {
          name: 'スペシャルセイバー',
          rules: [
            { period: '購入後～出発55日前', fee: '税抜運賃額の約5%相当額' },
            { period: '出発54日前～出発前', fee: '税抜運賃額の約50%相当額' },
            { period: '出発後', fee: '税抜運賃額の100%' },
          ],
          note:
            '※予約の取り消しのみを行い、後日払い戻しを行う場合は、払い戻し手続き日の手数料が適用となります。',
        },
      ],
    },
    ANA: {
      name: 'ANA',
      code: 'ANA',
      roundTripCautions: {
        lead:
          '⚠️ ANAの往復予約で片道キャンセルの場合は、航空会社の規約に基づく厳格なルールがあります。必ず下記内容をご確認ください。',
        items: [
          {
            title:
              '【旅行開始前（出発前）】一部区間の払い戻し不可（航空会社規定）',
            body:
              '航空会社の規定により、出発前の一部区間のみの払い戻しは一切承れません。往復など予約記録全体を一度すべて払い戻し（キャンセル）した後に、ご利用になる区間を新規にご購入いただく必要があります。',
            example:
              '（例）往路（行き）のみを解約したい場合も、復路（帰り）を含め一度すべて払い戻した上で、復路便を新規で再購入していただく必要があります。',
          },
          {
            title:
              '【払い戻しできないケース】旅程が成り立たない場合（航空会社規定）',
            body:
              '払い戻しの際、搭乗済み区間が旅程として成り立たない場合は、航空会社の規定により払い戻しを承れません。',
            example:
              '【具体例：石垣〜東京の往復で復路が那覇経由の場合】\n・往路：東京（羽田）⇒ 石垣\n・復路：石垣 ⇒ 那覇 ⇒ 東京（羽田）\n上記で「往路」と帰りの「石垣⇒那覇」まで搭乗した後に、最後の「那覇⇒東京」のみを払い戻しすることは、航空会社の規定上一切できません。',
          },
          {
            title:
              '【搭乗後】ケース①：復路（帰り）のみを解約する場合（返金が0円になる事例）',
            body:
              '往路搭乗後に未使用の復路だけを払い戻す場合、航空会社の規約に基づき「往復総額」から「搭乗済み区間の通常片道運賃（割引なし）」を差し引く精算を行います。そのため高額な通常運賃が差し引かれ、「運賃部分の払い戻し額が0円（返金なし）」となる事例が非常に多くなっております。',
            example:
              '【精算例】往復4万円（片道2万）で購入、往路搭乗後に復路解約。往路の通常運賃が3.5万円、取消手数料30%の場合：\n差額（4万−3.5万＝5,000円） − 手数料1.2万円 ＝ マイナス（返金なし）',
          },
          {
            title:
              '【乗り遅れ】ケース②：往路（行き）に乗り遅れ・解約を忘れた場合',
            body:
              '行きの便を取り消さないまま出発時刻を経過した場合、航空会社の規約に基づき往復運賃の100％が取消手数料となるため、まだ出発前の帰りの便（復路）であっても連動して全額返金不可（航空会社規定）となります。',
            required:
              '【必須】乗り遅れる可能性がある時は当サイトへの連絡前に、まずお客様ご自身で直接ANAへ連絡し、必ず「往路便の出発時刻前」に取り消し処理を完了させてください。',
          },
        ],
      },
      sections: [
        {
          title: '航空会社（ANA）設定の手数料（2026年5月19日以降のご搭乗分）',
          fares: [
            {
              name: 'フレックス',
              rules: [
                {
                  period: '航空券購入後～出発時刻前',
                  fee: '500円',
                },
                {
                  period: '出発後',
                  fee: '税抜運賃額の100%',
                },
              ],
            },
            {
              name: 'スタンダード',
              rules: [
                {
                  period: '搭乗日45日前まで',
                  fee: '税抜運賃額の約10％相当額',
                },
                {
                  period: '搭乗日44日前～搭乗日28日前',
                  fee: '税抜運賃額の約20％相当額',
                },
                {
                  period: '搭乗日27日前～出発時刻前',
                  fee: '税抜運賃額の約30％相当額',
                },
                { period: '出発後', fee: '運賃額の100%' },
              ],
            },
            {
              name: 'シンプル',
              rules: [
                {
                  period: '搭乗日45日前まで',
                  fee: '税抜運賃額の約20％相当額',
                },
                {
                  period: '搭乗日44日前～搭乗日28日前',
                  fee: '税抜運賃額の約40％相当額',
                },
                {
                  period: '搭乗日27日前～出発時刻前',
                  fee: '税抜運賃額の約60％相当額',
                },
                { period: '出発後', fee: '運賃額の100%' },
              ],
            },
            {
              name: '株主優待割引',
              rules: [
                {
                  period: '航空券購入後～出発時刻前',
                  fee: '500円',
                },
                {
                  period: '出発後',
                  fee: '税抜運賃額の100%',
                },
              ],
            },
          ],
        },
      ],
    },
    ADO: {
      name: 'AIRDO',
      code: 'ADO',
      fares: [
        {
          name: '普通料金(普通運賃)',
          rules: [
            {
              period: '購入後～出発時刻前まで',
              fee: '取消手数料はかかりません※払戻手数料440円はかかります',
            },
            {
              period: '出発後',
              fee:
                '取消手数料6,000円＋払戻手数料440円　※小児は取消手数料3,000円＋払戻手数料440円',
            },
          ],
        },
        {
          name: 'DOバリュー3 / DOバリュー1',
          rules: [
            {
              period: '購入後～搭乗日55日前まで',
              fee: '取消手数料はかかりません※払戻手数料440円はかかります',
            },
            {
              period: '搭乗日54日前～出発前まで',
              fee: '運賃の5%相当額＋払戻手数料440円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
        {
          name: 'AIRDOスペシャル75 / 55 / 45 / 28 / 21',
          rules: [
            {
              period: '購入後～搭乗日55日前まで',
              fee: '取消手数料はかかりません※払戻手数料440円はかかります',
            },
            {
              period: '搭乗日54日前～出発前まで',
              fee: '運賃の40%相当額＋払戻手数料440円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
      ],
    },
    FDA: {
      name: 'FDA',
      code: 'FDA',
      fares: [
        {
          name: '普通運賃',
          rules: [
            {
              period: '購入後～出発時刻前まで',
              fee: '取消手数料はかかりません。',
            },
            { period: '出発後', fee: '運賃の100%' },
          ],
        },
        {
          name: 'Dreamフレックス',
          rules: [
            { period: '購入後～45日前まで', fee: '1,500円' },
            { period: '搭乗日44日前～出発前まで', fee: '1,500円' },
            { period: '出発後', fee: '運賃の100％' },
          ],
        },
        {
          name: 'Dreamプライス',
          rules: [
            { period: '購入後～45日前まで', fee: '2,000円' },
            { period: '搭乗日44日前～出発前まで', fee: '5,000円' },
            { period: '出発後', fee: '運賃の100％' },
          ],
        },
      ],
    },
    SKY: {
      name: 'スカイマーク',
      code: 'SKY',
      fares: [
        {
          name: '普通運賃',
          rules: [
            {
              period: '購入後～出発時刻まで',
              fee: '取消手数料はかかりません※払戻手数料500円はかかります',
            },
            { period: '出発後', fee: '5,000円＋払戻手数料500円' },
          ],
        },
        {
          name: 'たす得',
          rules: [
            {
              period: '購入後～出発時刻前まで',
              fee: '4,000円＋払戻手数料500円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
        {
          name: 'いま得',
          rules: [
            {
              period: '購入後～出発時刻まで',
              fee: '6,000円＋払戻手数料500円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
      ],
    },
    SFJ: {
      name: 'スターフライヤー',
      code: 'SFJ',
      fares: [
        {
          name: '普通運賃 / 株主優待割引運賃',
          rules: [
            { period: '購入後～出発時刻前まで', fee: '500円' },
            { period: '出発後', fee: '運賃の100％相当額' },
          ],
          note: '※出発時刻以降は消費税と旅客施設使用料（PFC）のみ返金',
        },
        {
          name: 'STAR',
          rules: [
            {
              period: '購入後～搭乗日45日前まで',
              fee: '運賃の約10％相当額',
            },
            {
              period: '搭乗日44日前～搭乗日28日前まで',
              fee: '運賃の約20％相当額',
            },
            {
              period: '搭乗日27日前～出発時刻前まで',
              fee: '運賃の約30％相当額',
            },
            { period: '出発後', fee: '運賃の100％相当額' },
          ],
          note: '※出発時刻以降は消費税と旅客施設使用料（PFC）のみ返金',
        },
        {
          name: 'そら旅',
          rules: [
            {
              period: '購入後～搭乗日45日前まで',
              fee: '運賃の約20％相当額',
            },
            {
              period: '搭乗日44日前～搭乗日28日前まで',
              fee: '運賃の約40％相当額',
            },
            {
              period: '搭乗日27日前～出発時刻前まで',
              fee: '運賃の約60％相当額',
            },
            { period: '出発後', fee: '運賃の100％相当額' },
          ],
          note: '※出発時刻以降は消費税と旅客施設使用料（PFC）のみ返金',
        },
      ],
    },
    SNA: {
      name: 'ソラシドエア',
      code: 'SNA',
      fares: [
        {
          name: '普通運賃',
          rules: [
            {
              period: '購入後～出発時刻前まで',
              fee: '取消手数料はかかりません※払戻手数料440円はかかります',
            },
            {
              period: '出発後',
              fee:
                '羽田＝那覇：8,000円＋払戻手数料440円\n羽田＝宮崎・熊本・長崎・鹿児島・大分 / 那覇＝宮崎・鹿児島・神戸・名古屋(中部)・福岡 / 名古屋(中部)＝宮崎・鹿児島：6,000円＋払戻手数料440円\n那覇＝石垣：4,000円＋払戻手数料440円',
            },
          ],
        },
        {
          name: '特売り1日前',
          rules: [
            {
              period: '購入後～出発時刻前まで',
              fee:
                '羽田＝那覇：1,500円＋払戻手数料440円\n羽田＝宮崎・熊本・長崎・鹿児島・大分 / 那覇＝宮崎・鹿児島・神戸・名古屋(中部)・福岡 / 名古屋(中部)＝宮崎・鹿児島：1,000円＋払戻手数料440円\n那覇＝石垣線：500円＋払戻手数料440円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
        {
          name: '特売り3日前',
          rules: [
            {
              period: '購入後～出発時刻前まで',
              fee:
                '羽田＝那覇：2,000円＋払戻手数料440円\n羽田＝宮崎・熊本・長崎・鹿児島・大分 / 那覇＝宮崎・鹿児島・神戸・名古屋(中部)・福岡 / 名古屋(中部)＝宮崎・鹿児島：1,500円＋払戻手数料440円\n那覇＝石垣線：1,000円＋払戻手数料440円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
        {
          name: '特売り7日前',
          rules: [
            {
              period: '購入後～出発時刻前まで',
              fee:
                '羽田＝那覇：2,500円＋払戻手数料440円\n羽田＝宮崎・熊本・長崎・鹿児島・大分 / 那覇＝宮崎・鹿児島・神戸・名古屋(中部)・福岡 / 名古屋(中部)＝宮崎・鹿児島：2,000円＋払戻手数料440円\n那覇＝石垣線：1,500円＋払戻手数料440円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
        {
          name: 'バーゲン14',
          rules: [
            {
              period: '購入後～出発時刻前まで',
              fee:
                '羽田＝那覇：4,000円＋払戻手数料440円\n羽田＝宮崎・熊本・長崎・鹿児島・大分 / 那覇＝宮崎・鹿児島・神戸・名古屋(中部)・福岡 / 名古屋(中部)＝宮崎・鹿児島：3,000円＋払戻手数料440円\n那覇＝石垣線：2,000円＋払戻手数料440円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
        {
          name: 'バーゲン75 / バーゲン60 / バーゲン35 / バーゲン28',
          rules: [
            {
              period: '購入後～搭乗日60日前まで',
              fee: '取消手数料はかかりません※払戻手数料440円はかかります',
            },
            {
              period: '搭乗日59日前～30日前',
              fee: '運賃の40%相当額＋払戻手数料440円',
            },
            {
              period: '搭乗日29日前～出発時刻前まで',
              fee: '運賃の60%相当額＋払戻手数料440円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
      ],
    },
    GK: {
      name: 'ジェットスター',
      code: 'GK',
      fares: [
        {
          name: 'Starter',
          rules: [{ period: '購入後～出発後', fee: '運賃の100%相当額' }],
        },
      ],
    },
    MM: {
      name: 'ピーチ',
      code: 'MM',
      fares: [
        {
          name: 'スタンダードプラス',
          rules: [
            {
              period: '購入後～出発時刻1時間前まで',
              fee: '取消手数料：500円＋発券手数料640円',
            },
            {
              period: '出発後',
              fee: '運賃の100%相当額　※ピーチポイントの払戻しもありません。',
            },
          ],
        },
        {
          name: 'スタンダード',
          rules: [
            {
              period: '購入後～搭乗の30日前まで',
              fee:
                '運賃の100%相当額(1,000円差し引いた金額をピーチポイントで払戻し)',
            },
            {
              period: '搭乗の29日前以降～出発時刻1時間前まで',
              fee:
                '運賃の100%相当額(3,000円差し引いた金額をピーチポイントで払戻し)',
            },
            {
              period: '出発後',
              fee: '運賃の100%相当額　※ピーチポイントの払戻しもありません。',
            },
          ],
          note: '※現金の払戻しでは無い為、弊社手数料等の払い戻しはありません。',
        },
        {
          name: 'ミニマム',
          rules: [{ period: '購入後～出発後', fee: '運賃の100%相当額' }],
        },
      ],
    },
    IJ: {
      name: 'スプリング・ジャパン',
      code: 'IJ',
      fares: [
        {
          name: 'スプリング',
          rules: [
            { period: '購入後～搭乗日31日前まで', fee: '運賃の30%相当額' },
            { period: '搭乗日30日前～16日前まで', fee: '運賃の40%相当額' },
            { period: '搭乗日15日前～8日前まで', fee: '運賃の50%相当額' },
            { period: '搭乗日7日前～24時間より前', fee: '運賃の60%相当額' },
            { period: '搭乗24時間前～出発時刻前', fee: '運賃の100%相当額' },
          ],
        },
        {
          name: 'ラッキースプリング',
          rules: [
            { period: '購入後～搭乗日31日前まで', fee: '運賃の50％相当額' },
            { period: '搭乗日30日前～16日前まで', fee: '運賃の60％相当額' },
            { period: '搭乗日15日前～8日前まで', fee: '運賃の70％相当額' },
            { period: '搭乗日7日前～24時間より前', fee: '運賃の80％相当額' },
            { period: '搭乗24時間前～出発時刻前', fee: '運賃の100%相当額' },
          ],
        },
      ],
    },
    TOK: {
      name: 'トキエア',
      code: 'TOK',
      fares: [
        {
          name: 'トキビズ',
          rules: [
            {
              period: '購入後～出発時刻前',
              fee: '（3月29日搭乗分まで）3,000円　（3月30日搭乗分から）500円',
            },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
        {
          name: 'トキトク',
          rules: [
            { period: '購入後～出発時刻前', fee: '5,000円' },
            { period: '出発後', fee: '運賃の100%相当額' },
          ],
        },
      ],
    },
  },

  // 後方互換性のため、MAX_RETRYをMAX_RETRY_APPLICATIONのエイリアスとして保持
  get MAX_RETRY() {
    return this.MAX_RETRY_APPLICATION;
  },
};

// 決済関連定数をPaymentMethods.jsから再エクスポート（互換性維持）
export {
  PAYMENT_METHODS,
  PAYMENT_CATEGORIES,
  PAYMENT_CATEGORIES_FOR_HOTEL,
  MAX_RETRY as MAX_RETRY_PAYMENT,
  WAITING_MSEC as WAITING_MSEC_PAYMENT,
} from './PaymentMethods';
